import { useState } from 'react';
import { PHONE_DISPLAY, BUSINESS_NAME } from '../../../lib/businessInfo';

export function SWWashingtonFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'Do you deliver to my city in Southwest Washington?',
      answer: `Yes! ${BUSINESS_NAME} delivers throughout Southwest Washington including Vancouver, Longview, Kelso, Camas, Washougal, Battle Ground, and surrounding areas. We'll bring the vehicle to your home or workplace for a test drive and complete the paperwork on-site.`,
    },
    {
      question: 'How much does delivery cost?',
      answer: "Delivery is FREE for most locations in Southwest Washington and Northwest Oregon. For areas outside our standard service zone, we may charge a small fuel fee, but we'll always discuss this upfront before scheduling delivery.",
    },
    {
      question: 'Can I test drive before buying?',
      answer: "Absolutely! We encourage test drives. When we deliver the vehicle to you, you'll have time to inspect it, take it for a drive, and ask any questions. There's no pressure to buy on the spot.",
    },
    {
      question: 'What if I need financing?',
      answer: "We work with multiple lenders to help you get approved, even with bad credit or no credit history. You can apply online or over the phone, and we'll have financing options ready when we deliver the vehicle.",
    },
    {
      question: 'Do you accept trade-ins?',
      answer: "Yes! We offer competitive trade-in values. You can get an instant estimate online, and we'll finalize the trade-in value when we deliver your new vehicle. We handle all the paperwork.",
    },
    {
      question: 'Are your vehicles inspected?',
      answer: "Every vehicle goes through a thorough inspection and reconditioning process. We provide a detailed vehicle history report and disclose any known issues upfront. No surprises.",
    },
    {
      question: 'What areas do you serve?',
      answer: "We serve all of Southwest Washington including Clark, Cowlitz, Skamania, and Wahkiakum counties, plus Northwest Oregon including Clatsop, Columbia, and Tillamook counties.",
    },
    {
      question: 'How do I get started?',
      answer: `Browse our inventory online, then call us at ${PHONE_DISPLAY} or submit an inquiry form. We'll answer your questions, arrange financing if needed, and schedule a convenient delivery time.`,
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Questions from <span className="text-teal-600">SW Washington Buyers</span>
          </h2>
          <p className="text-lg text-slate-600">
            Everything you need to know about buying a used car from Oregon while living in Washington.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const btnId = `swwa-faq-btn-${index}`;
            const panelId = `swwa-faq-panel-${index}`;
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="bg-white border border-slate-200 rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-all"
              >
                <button
                  id={btnId}
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  className="w-full flex items-center justify-between gap-4 p-6 text-left cursor-pointer hover:bg-slate-50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-teal-600"
                >
                  <h3 className="text-lg font-semibold text-slate-900 pr-4">
                    {faq.question}
                  </h3>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0" aria-hidden="true">
                    <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line text-2xl text-teal-600 transition-transform`}></i>
                  </div>
                </button>
                {isOpen && (
                  <div
                    id={panelId}
                    role="region"
                    aria-labelledby={btnId}
                    className="px-6 pb-6"
                  >
                    <p className="text-slate-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-600 mb-6">
            Still have questions? We're here to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+18554686348"
              className="inline-flex items-center justify-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-teal-600"
            >
              <i className="ri-phone-line text-xl"></i>
              1-855-468-6348
            </a>
            <a
              href="/contact"
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-50 border-2 border-slate-300 text-slate-900 px-8 py-4 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-slate-500"
            >
              <i className="ri-message-3-line text-xl"></i>
              Send a Message
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SWWashingtonFaq;
